<mat-card>
  <mc-loader *ngIf="(loadingState.loading$ | async) || (loginLoadingState.loading$ | async)"></mc-loader>

  <div class="mat-card-header">
    <mc-auth-card-header></mc-auth-card-header>
  </div>

  <mat-card-content>
    <div *ngIf="loadingState.generalError$ | async as generalError" class="error-pane">
      <mc-error-code-expansion-panel [generalErrorCode]="generalError" [detailedErrorCodes]="loadingState.detailedErrors$ | async"></mc-error-code-expansion-panel>
    </div>

    <p class="mc-form-title text-x-large">Log in with MadCap<sup class="mc-text-super">&reg;</sup> ID</p>

    <form #loginForm="ngForm" novalidate [ngFormOptions]="{ updateOn: 'submit' }" (ngSubmit)="login(loginForm)">
      <ng-container *ngIf="centralInstances$ | async as centralInstances">
        <mat-form-field *ngIf="centralInstances.length > 0" class="mc-form-field" color="secondary">
          <mat-select [(ngModel)]="selectedCentralInstance" name="centralInstance" (selectionChange)="onSelectedCentralInstanceChanged($event.value)" placeholder="Server Location" i18n-placeholder="The placeholder for the server location selector">
            <mat-option *ngFor="let centralInstance of centralInstances" [value]="centralInstance">
              {{centralInstance?.Description}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <mat-form-field class="mc-form-field" color="secondary">
        <input matInput type="email" autocomplete="username" [(ngModel)]="email" name="email" placeholder="Email Address" i18n-placeholder="The placeholder for the login email address field" email required autofocus>
        <mat-error i18n="The login email address field is required error message">Email is required</mat-error>
      </mat-form-field>

      <mat-form-field class="mc-form-field" color="secondary">
        <input matInput type="password" autocomplete="current-password" [(ngModel)]="password" name="password" placeholder="Password" i18n-placeholder="The placeholder for the login password field" required>
        <mat-error i18n="The login password field is required error message">Password is required</mat-error>
      </mat-form-field>

      <mc-error-code-expansion-panel *ngIf="loginLoadingState.generalError$ | async as generalErrorCode" [showIcon]="false" [generalErrorCode]="generalErrorCode" [detailedErrorCodes]="loginLoadingState.detailedErrors$ | async" class="mc-error-message"></mc-error-code-expansion-panel>

      <button mat-raised-button class="mc-admin-login-card-login-button" color="primary" type="submit" i18n="The login button">Log in</button>
      <a *ngIf="forgotPasswordRouteCommand$ | async as forgotPasswordRouteCommand" [queryParams]="forgotPasswordRouteCommand.extras?.queryParams" [routerLink]="forgotPasswordRouteCommand.commands" i18n="The forgot password link">Forgot password</a>
    </form>
  </mat-card-content>

  <mat-card-footer>
    <div class="mc-form-spacer"></div>
    <mc-divider>OR</mc-divider>
    <div class="mc-form-spacer"></div>
    <a mat-raised-button class="mc-admin-login-card-login-button" color="link" [routerLink]="licenseUrlRouteCommands$ | async" i18n="The license url link">Log in to a specific license</a>
    <a class="mc-button-small mc-admin-login-card-trial-button" color="basic-muted" [href]="madcapUrl" target="_blank" i18n="The user trial link" mat-flat-button>SIGN UP FOR A FREE 30-DAY TRIAL</a>
  </mat-card-footer>
</mat-card>